export default {
  getHead: () => {
    return [{name: '시설물명'}, {name: '작업내용'}, {name: '재해형태'}, {name: '평가일'}, {name: '소속명'}, {name: '부서명'}, {name: '작성자'}]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name // 시설물명
        case 1: return func.getContent(value).inputB_3 // 작업내용
        case 2: return func.getContentRiskList(func.getContent(value).riskAppraisalList)// 재해형태
        case 3: return func.getContent(value).inputB_4 // 평가일
        case 4: return func.getContent(value).stdInfo.department // 소속명
        case 5: return func.getContent(value).stdInfo.com_name // 부서명
        case 6: return value.user ? value.user.name : value.author.name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.inputB_4) {
      nav.dateTarget = 'content$body.inputB_4'
      nav.dateBegin = 'nav.value.inputB_4.sDate'
      nav.dateEnd = 'nav.value.inputB_4.eDate'
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    if (nav.value.disasterType) returnData.push('content$body.disasters*%[:default_disaster]%')

    switch (nav.value.searchType) {
      case '시설물명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
      case '작업내용': returnData.push('content$body.inputB_3*%[:default_skw]%'); break
      case '소속명': returnData.push('content$body.stdInfo.department*%[:default_skw]%'); break
      case '부서명': returnData.push('content$body.stdInfo.com_name*%[:default_skw]%'); break
      case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }

    return returnData
  },
}
